<template>
  <div class="lang-switcher">
    <a href="#pl" v-if="$i18n.locale !== 'pl'" @click.prevent="setLang('pl')">Polski</a>
    <a href="#en" v-if="$i18n.locale !== 'en'" @click.prevent="setLang('en')">English</a>
    <a href="#de" v-if="$i18n.locale !== 'de'" @click.prevent="setLang('de')">Deutsch</a>
    <a href="#it" v-if="$i18n.locale !== 'it'" @click.prevent="setLang('it')">Italiano</a>
    <a href="#fr" v-if="$i18n.locale !== 'fr'" @click.prevent="setLang('fr')">Français</a>
  </div>
</template>

<script>
export default {
  name: 'lang-switcher',
  methods: {
    setLang (langCode) {
      this.$i18n.locale = langCode;
      window.localStorage.setItem('headwear-crm-ui-language', langCode.replace(/[^a-z]/gmi, ''));
    }
  }
};
</script>

<style lang="scss" scoped>
.lang-switcher {
 display: flex;
 flex-wrap: wrap;
 justify-content: center;
 margin: 20px 0;

 a {
  padding: 20px;
 }
}
</style>
